import {
  AudioVideoComponent,
  FullwidthVideoComponent
} from '../../models/LessonComponent';
import React from 'react';

import { AudioVideoPlayer } from './AudioVideoPlayer';
import { WithCaption } from './WithCaption';

interface AudioVideoProps {
  component: AudioVideoComponent;
  onSubmit: (value: string) => void; //* The 'value' is JSON of VideoStatus.
}

interface FullwidthVideoProps {
  component: FullwidthVideoComponent;
  onSubmit: (value: string) => void; //* The 'value' is JSON of VideoStatus.
}

export function AudioVideo(props: AudioVideoProps | FullwidthVideoProps) {
  const audioVideoPlayerComponent = (
    <AudioVideoPlayer
      key={props.component.answer}
      component={props.component}
      onSubmit={props.onSubmit}
    />
  );
  return props.component.type === 'video' ||
    props.component.type === 'audio' ? (
    <WithCaption {...(props as AudioVideoProps)}>
      {audioVideoPlayerComponent}
    </WithCaption>
  ) : (
    audioVideoPlayerComponent
  );
}
